<template>
    <section class="td-slider" :style="box">
        <div :class="container" v-if="slides.length">
            <div class="glider-contain">
                <div
                        class="glider td-slider__slider"
                        @mouseup="checkSwitchSlide()"
                >
                    <div
                            class="td-slider__slide"
                            v-for="(image, idx) in slides"
                            :key="idx"
                    >
                        <img :src="image.file_name" alt="">
                    </div>
                </div>

                <button role="button" aria-label="Previous" class="glider-prev" @click="switchSlide('-')"></button>
                <button role="button" aria-label="Next" class="glider-next" @click="switchSlide('+')"></button>

                <div role="tablist" class="dots"></div>

                <div class="td-slider__thumbnails-btns" v-show="windowWidth > 480">
                    <div class="td-slider__thumbnails-slider-btns">
                        <div
                                class="td-slider__thumbnail-btn"
                                :class="{'selected': isActiveSlide == idx}"
                                v-for="(thumbnail, idx) in slides"
                                :key="idx"
                                @click="selectThumbnail(idx)"
                        >
                            <img :src="thumbnail.file_name" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!!textarea" class="container-small">
            <p>{{ textarea }}</p>
        </div>
    </section>
</template>

<script>
    import mixin from '@/mixins/sections/styleSettings'
    import getBlogImg from "@/helpers/getBlogImg";

    export default {
        mixins: [mixin],
        data() {
            return {
                isActiveSlide: 0,
                windowWidth: null
            }
        },
        beforeMount() {
            this.getWindowWidth()
        },
        mounted() {
            this.initSlider()
            window.onresize = (event) => {
                this.getWindowWidth()
            }
        },
        methods: {
            getWindowWidth() {
                this.windowWidth = window.innerWidth
            },
            initSlider() {
                new Glider(document.querySelector('.td-slider__slider'), {
                    slidesToShow: 1,
                    draggable: true,
                    dots: '.dots',
                    arrows: {
                        prev: '.glider-prev',
                        next: '.glider-next'
                    }
                });

                new Glider(document.querySelector('.td-slider__thumbnails-slider-btns'), {
                    draggable: true,
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 5
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 4
                            }
                        },
                        {
                            breakpoint: 721,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 481,
                            settings: {
                                slidesToShow: 2
                            }
                        }
                    ]
                });
            },
            switchSlide(sign) {
                sign == '+'
                    ? this.isActiveSlide += 1
                    : this.isActiveSlide -= 1
            },
            selectThumbnail(idx) {
                document.querySelectorAll('.glider-dot')[idx].click()
                this.isActiveSlide = idx
            },
            checkSwitchSlide() {
                document.querySelectorAll('.td-slider__slide').forEach((elSlide, idx) => {
                    if (elSlide.classList.contains('active')) {
                        this.isActiveSlide = idx
                        return
                    }
                })
            }
        },
        computed: {
            // hasData to be in mixin
            slides() {
                return this.hasData.img.map(function (i) {
                    return {
                        id: i.id,
                        file_name: getBlogImg( i.file_name)
                    }

                });
            },
            textarea() {
                return this.hasData.textarea
            }
        }
    }
</script>
